/**
 * Consolidation Readiness (FSD 2.2.7 "Check Readiness", FIN-F07-V01 and V02): for one
 * group and one reporting period, every member's blockers and the group's warnings.
 * Read-only, gated by `consol.readiness.read` as `GET /consol-groups/:id/readiness` is.
 */

import type { RouteRecordRaw } from 'vue-router'

import { CONSOL_PERMISSIONS } from '@/modules/consol/permissions'

export const CONSOL_READINESS_ROUTES: RouteRecordRaw[] = [
  {
    path: '/consol/readiness',
    name: 'consol-readiness',
    component: () => import('@/modules/consol/readiness/ReadinessView.vue'),
    meta: { titleKey: 'consol.routeTitles.readiness', permission: CONSOL_PERMISSIONS.readinessRead },
  },
]
